import { render, staticRenderFns } from "./validating-panel.vue?vue&type=template&id=256c2421&scoped=true&"
import script from "./validating-panel.vue?vue&type=script&lang=ts&"
export * from "./validating-panel.vue?vue&type=script&lang=ts&"
import style0 from "./validating-panel.vue?vue&type=style&index=0&id=256c2421&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256c2421",
  null
  
)

export default component.exports